"use strict";

var _regeneratorRuntime = require("/root/ui-api/node_modules/@babel/runtime/regenerator");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

var _crossFetch = _interopRequireDefault(require("cross-fetch"));

var _abortController = _interopRequireDefault(require("abort-controller"));

var _excluded = ["timeout"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var COMMON_TIMEOUT = 10000;

function fetchEx(_x, _x2) {
  return _fetchEx.apply(this, arguments);
}

function _fetchEx() {
  _fetchEx = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(url, opts) {
    var timeout, restOpts, controller;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            timeout = opts.timeout, restOpts = _objectWithoutProperties(opts, _excluded);

            if (!restOpts.signal) {
              if (timeout === 0 || timeout === undefined) {
                timeout = COMMON_TIMEOUT;
              }

              if (timeout !== null) {
                controller = new _abortController.default();
                setTimeout(function () {
                  return controller.abort();
                }, timeout);
                restOpts.signal = controller.signal;
              }
            }

            _context.next = 4;
            return (0, _crossFetch.default)(url, restOpts);

          case 4:
            return _context.abrupt("return", _context.sent);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchEx.apply(this, arguments);
}

fetchEx.COMMON_TIMEOUT = COMMON_TIMEOUT;
fetchEx.AbortController = _abortController.default;
var _default = fetchEx;
exports.default = _default;